"use client"

import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"
import { Search, Filter } from "lucide-react"
import type { CallsFilters as CallsFiltersType } from "@/hooks/use-calls"

interface CallsFiltersProps {
  filters: CallsFiltersType
  totalCount: number
  showArchived: boolean
  onSearchChange: (search: string) => void
  onStatusChange: (status: string) => void
  onClearFilters: () => void
}

export function CallsFilters({
  filters,
  totalCount,
  showArchived,
  onSearchChange,
  onStatusChange,
  onClearFilters,
}: CallsFiltersProps) {
  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4">
      <div className="flex flex-wrap items-center gap-4">
        <div className="flex-1 min-w-[250px] max-w-md">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
            <Input
              placeholder="Search by phone, agent name..."
              value={filters.search}
              onChange={(e) => onSearchChange(e.target.value)}
              className="pl-10"
            />
          </div>
        </div>

        <div className="w-[150px]">
          <Select value={filters.status} onValueChange={onStatusChange}>
            <SelectTrigger>
              <SelectValue placeholder="Status" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All Status</SelectItem>
              <SelectItem value="done">Completed</SelectItem>
              <SelectItem value="failed">Failed</SelectItem>
              <SelectItem value="in_progress">In Progress</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div className="flex items-center gap-2">
          <Button variant="outline" size="sm" onClick={onClearFilters}>
            <Filter className="w-4 h-4 mr-1" />
            <span>Clear</span>
          </Button>
          <div className="text-sm text-gray-500 whitespace-nowrap">
            {totalCount} <span>{showArchived ? "archived" : "calls"}</span>
          </div>
        </div>
      </div>
    </div>
  )
}
